<template>
  <v-card class="ma-4">
    <v-toolbar dark>
      <v-toolbar-side-icon @click="showHowToPlay = !showHowToPlay"></v-toolbar-side-icon>
      <v-toolbar-title>How to Play</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-list v-show="showHowToPlay">
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Layout</v-list-tile-title>
          <v-list-tile-sub-title>Your hand is at the bottom, the bot is at the top. Chip piles on the left.</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Goal</v-list-tile-title>
            <v-list-tile-sub-title>Reach 15+ points. Buy cards to get points.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>What you can do on your turn (one of these)</v-list-tile-title>
            <v-list-tile-sub-title>1. Take 3 different color Chips (from left side) OR take 2 of the same color IF there are 4 of that color available.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-sub-title>2. Buy a card from the board if you have the right amount of that color.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-sub-title>3. Reserve a card from the board. This goes in your hand off to the side and can be bought anytime later.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Taking Chips</v-list-tile-title>
            <v-list-tile-sub-title>If you have over 10 chips at the end of your turn then you have to discard chips until you have 10.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-sub-title>Click on your own chip pile to discard a chip.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Reserving</v-list-tile-title>
            <v-list-tile-sub-title>When you reserve a card you also get a Yellow chip (if available) which can be used as any color chip.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-sub-title>You can only have up to 3 reserve cards at a time.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Buying</v-list-tile-title>
            <v-list-tile-sub-title>Cards are payed for in chips. Cards are discounted for each color card you have. Cards are not spent.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-sub-title>For example, if a card costs 3 green and you have 2 green chips and 1 green card. You only pay 2 green chips for it.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-sub-title>When you buy a card the Yellow chips are only spent if you cannot afford the card without them.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Brownies</v-list-tile-title>
            <v-list-tile-sub-title>These are not regular cards, you cannot buy them, you earn them.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-sub-title>If you have the number of each color card at the end of your turn you will automatically get a brownie.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-sub-title>Brownies give you points but dont count towards any colors. They do not replenish.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>End Game</v-list-tile-title>
            <v-list-tile-sub-title>If there is a tie in points then the winner is whoever has less cards.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-sub-title>If the player who went first reaches 15+ points first then the other player gets another turn to try to beat their points.</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
  export default {
    data() {
      return {
        showHowToPlay: true,
      }
    },
    methods: {

    }
  }
</script>
